import { Col } from 'react-bootstrap'
import { Card, Container, Row } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import React, { useEffect, useState } from 'react';
import { useLoader } from '../../_helper/LoaderContext';
import { getPharmacyProfile, updatePharmacyProfile } from './Service/ManageClinicUsersService';
import { toast } from 'react-toastify';
import { usePharmacy } from '../../_helper/PharmacyProvider';
import { User, Camera, DollarSign } from 'react-feather';
import { MdLocalPharmacy } from "react-icons/md";
import errorImage from "../../assets/images/blank_profile.png"
import pharmacyErrImg from "../../assets/images/hospital-placeholder.png"
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useLicense } from '../../_helper/license/LicenseContext';
import S3ImageLoader from '../../S3ImageLoader';
import LoadGoogleMapsAPI from '../LoadGoogleMapsAPI';
import PlacesAutocomplete from 'react-places-autocomplete';

export default function Home() {
    const { setLoading } = useLoader()
    const [apiData, setApiData] = useState({});
    const { pharmacyPOS, setPharmacyPOS } = usePharmacy();
    const { setSkipValidation } = useLicense();
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        facility_name: "",
        email: "",
        logo: "",
        full_name: "",
        mobile: "",
        phone_code: "",
        contact_email: "",
        address: "",
        city: "",
        country: "",
        state: "",
        stateCode: "",
        conversionRates: {}
    });
    const [errors, setErrors] = useState({});
    const [googleMapApiLoaded, setGoogleMapApiLoaded] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [fullPhone, setFullPhone] = useState("");
    const [address, setAddress] = useState(formData.address);
    const [imageFile, setImageFile] = useState(null);
    const [imageSource, setImageSource] = useState(errorImage);

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        setLoading(true)
        try {
            const res = await getPharmacyProfile();
            if (res.data.status === 'success') {
                const data = res.data.data;
                setApiData(data);
                setLogoPreview(data.logo && `${process.env.REACT_APP_IMAGE}${data.logo}`)

                // Build full phone number with country code
                const phoneCode = data.contact_person?.phone_code || "91";
                const mobileNumber = data.contact_person?.mobile || "";
                const fullPhoneNumber = phoneCode + mobileNumber;
                setFullPhone(fullPhoneNumber);

                setFormData({
                    facility_name: data?.facility_name || "",
                    email: data?.email || "",
                    logo: data?.logo || "",
                    first_name: data.contact_person?.first_name || "",
                    middle_name: data.contact_person?.middle_name || "",
                    last_name: data.contact_person?.last_name || "",
                    full_name: data.contact_person?.full_name || "",
                    mobile: mobileNumber,
                    phone_code: phoneCode,
                    contact_email: data.contact_person?.contact_email || "",
                    address: data.contact_person?.address || "",
                    city: data.contact_person?.city || "",
                    country: data.contact_person?.country || "",
                    state: data?.state || "",
                    stateCode: data?.stateCode || "",
                    conversionRates: data?.conversionRates || {}
                });
                if (data?.contact_person?.profile_picture) {
                    setImageFile(null);
                    setImageSource(null);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    const [logoPreview, setLogoPreview] = useState(pharmacyErrImg);

    const handleInputChange = (eOrValue, fieldName = null) => {
        if (typeof eOrValue === "object" && eOrValue.target) {
            const { name, value } = eOrValue.target;
            setFormData(prev => ({ ...prev, [name]: value }));
            setErrors(prev => ({ ...prev, [name]: "" }));
        } else if (fieldName) {
            if (fieldName === 'address') {
                setAddress(eOrValue)
            }
            setFormData((prevValues) => ({
                ...prevValues,
                [fieldName]: eOrValue,
            }))
            setErrors(prev => ({ ...prev, [fieldName]: "" }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

        if (!formData.facility_name?.trim()) newErrors.facility_name = t("Pharmacy Name is required");

        if (!formData.email?.trim()) {
            newErrors.email = t("Email is required");
        } else if (!emailPattern.test(formData.email.trim())) {
            newErrors.email = t("Please enter a valid email address");
        }

        if (!formData.first_name?.trim()) newErrors.first_name = t("First Name is required");
        if (!formData.last_name?.trim()) newErrors.last_name = t("Last Name is required");

        if (!formData.contact_email?.trim()) {
            newErrors.contact_email = t("Contact Email is required");
        } else if (!emailPattern.test(formData.contact_email.trim())) {
            newErrors.contact_email = t("Please enter a valid email address");
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handlePhoneChange = (value, countryData) => {
        setFullPhone(value);
        // Extract phone code and mobile number
        const phoneCode = value.slice(0, countryData.dialCode.length);
        const mobileNumber = value.slice(countryData.dialCode.length);

        setFormData(prev => ({
            ...prev,
            mobile: mobileNumber,
            phone_code: phoneCode,
            country: countryData.name // Optionally update country from phone input
        }));
    };

    const handleSelect = (selectedAddress) => {
        // Log the selected address
        console.log("Selected Address:", selectedAddress);
        // Update address state
        setAddress(selectedAddress);
        // Use geocoder to get latitude and longitude
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: selectedAddress }, (results, status) => {
            console.log("Geocoder Status:", status);

            if (status === 'OK') {
                const location = results[0].geometry.location;
                // console.log("Geocoder Results:", results);
                // console.log("Latitude:", location.lat());
                // console.log("Longitude:", location.lng());
                setFormData(prevValues => ({
                    ...prevValues,
                    address: selectedAddress,
                    city: selectedAddress.city,
                    country: selectedAddress.country,
                }));
                // Set latitude and longitude states
                setLatitude(location.lat());
                setLongitude(location.lng());
            } else {
                console.error('Geocode failed:', status);
            }
        });
    };

    const handleConversionRateChange = (currency, value) => {
        setFormData(prev => ({
            ...prev,
            conversionRates: {
                ...prev.conversionRates,
                [currency]: parseFloat(value) || 0
            }
        }));
    };

    const handleLogoChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => setLogoPreview(reader.result);
        reader.readAsDataURL(file);

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("logo", file);

            // SKIP VALIDATION BEFORE UPDATE - with reason
            setSkipValidation(true, "Logo upload in progress");

            const res = await updatePharmacyProfile(formData);

            if (res.data.status === "success") {
                toast.success(res.data.message);
                localStorage.setItem(
                    "currentPharmacyPOS",
                    JSON.stringify(res.data.data)
                );
                setPharmacyPOS(res.data.data);

                getData();

                // Give extra time for pharmacyPOS to update
                setTimeout(() => {
                    setSkipValidation(false, "Logo upload complete");
                }, 500);
            }
        } catch (error) {
            console.error(error);
            toast.warning("Failed to upload logo");
            setSkipValidation(false, "Logo upload failed");
        } finally {
            setLoading(false);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowedTypes = [
            'image/jpeg', 'image/jpg', 'image/png',
            'image/tiff', 'image/bpg', 'image/bmp',
            'image/heic', 'image/heif'
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.warning("Invalid image format");
            e.target.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setImageSource(reader.result); // ✅ local preview
        };
        reader.readAsDataURL(file);

        setImageFile(file);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.warning(t("Please fill all required fields"));
            return;
        }
        setLoading(true)
        try {
            // SKIP VALIDATION BEFORE UPDATE - with reason
            setSkipValidation(true, "Profile update in progress");

            const payload = {
                contact_person: {
                    first_name: formData.first_name,
                    middle_name: formData.middle_name,
                    last_name: formData.last_name,
                    full_name: formData.first_name + " " + formData.middle_name + " " + formData.last_name,
                    contact_email: formData.contact_email,
                    mobile: formData.mobile,
                    phone_code: formData.phone_code,
                    address: address || apiData?.contact_person?.address,
                    city: formData.city || apiData?.contact_person?.city,
                    country: formData.country || apiData?.contact_person?.country,
                }
            }
            const form_data = new FormData();
            form_data.append("facility_name", formData.facility_name);
            form_data.append("state", formData.state);
            form_data.append("stateCode", formData.stateCode);
            form_data.append("conversionRates", JSON.stringify(formData.conversionRates));
            form_data.append("contact_person", JSON.stringify(payload.contact_person));
            if (imageFile) {
                form_data.append('profile_picture', imageFile)
                // form_data.append(
                //     "contact_person[profile_picture]",
                //     imageFile,
                //     imageFile.name
                // );
            }

            const res = await updatePharmacyProfile(form_data);
            if (res.data.status === 'success') {
                toast.success(res.data.message);
                localStorage.setItem("currentPharmacyPOS", JSON.stringify(res.data.data));
                setPharmacyPOS(res.data.data);
                getData();

                // Give extra time for pharmacyPOS to update
                setTimeout(() => {
                    setSkipValidation(false, "Profile update complete");
                }, 500);
            }
        } catch (error) {
            console.log(error);
            // toast.warning("Failed to update profile");
            setSkipValidation(false, "Profile update failed");
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            <Breadcrumbs mainTitle="Profile" parent="Home" title="Profile" />
            <Container>
                <Row>
                    <Col >
                        <div className="row justify-content-center">
                            <div className="col-md-6 col-lg-4 mx-auto text-center">
                                {/* Logo & Basic Info */}
                                <Card>
                                    <div className="bg-gradient text-white p-5 position-relative" style={{
                                        background: 'linear-gradient(to right, #667eea, #764ba2)',
                                        borderRadius: '1rem 1rem 0 0'
                                    }}>
                                        <div className="">
                                            <div className="">
                                                <div className="position-relative d-inline-block">
                                                    {/* <img
                                                        src={logoPreview}
                                                        alt="Pharmacy Logo"
                                                        className="rounded-circle border border-5 border-white shadow-lg"
                                                        style={{ width: '160px', height: '160px', objectFit: 'cover' }}
                                                        onError={(e) => { e.target.src = pharmacyErrImg; }}
                                                    /> */}
                                                    <S3ImageLoader
                                                        className="m-0"
                                                        fileName={pharmacyPOS?.logo}
                                                        style={{ height: '160px', width: '160px', objectFit: 'cover', borderRadius: '100%' }}
                                                        alt="profile"
                                                        fallbackSrc={errorImage}
                                                    />
                                                    <label
                                                        htmlFor="logo-upload"
                                                        className="position-absolute bottom-0 end-0 bg-primary rounded-circle d-flex justify-content-center align-items-center shadow cursor-pointer"
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                        }}
                                                    >
                                                        <Camera size={18} className="text-white" style={{ cursor: 'pointer' }} />
                                                        <input
                                                            id="logo-upload"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={handleLogoChange}
                                                            className="d-none"
                                                        />
                                                    </label>
                                                </div>
                                                <p className="mt-3 mb-0 fw-semibold tw-text-black">
                                                    {t("Upload Pharmacy Logo")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Additional Pharmacy Info
                                    <div className="p-4">
                                        <div className="mb-3">
                                            <h6 className="fw-bold">{t("Base Currency")}</h6>
                                            <div className="d-flex align-items-center">
                                                <span className="badge bg-primary fs-6 me-2">
                                                    {apiData?.baseCurrency || "INR"}
                                                </span>
                                                <span className="text-muted">
                                                    {apiData?.allowedCurrencies?.join(", ")}
                                                </span>
                                            </div>
                                        </div>
                                        
                                        <div className="mb-3">
                                            <h6 className="fw-bold">{t("Status")}</h6>
                                            <span className={`badge ${apiData?.status === 'active' ? 'bg-success' : 'bg-warning'} fs-6`}>
                                                {apiData?.status || t("Inactive")}
                                            </span>
                                        </div>
                                        
                                        <div className="mb-3">
                                            <h6 className="fw-bold">{t("Verification")}</h6>
                                            <span className={`badge ${apiData?.is_verified ? 'bg-success' : 'bg-secondary'} fs-6`}>
                                                {apiData?.is_verified ? t("Verified") : t("Not Verified")}
                                            </span>
                                        </div>
                                    </div> */}
                                </Card>
                            </div>
                            <div className="col-md-12 col-lg-8">
                                <Card>
                                    <div className="p-5">
                                        <form onSubmit={handleSave}>
                                            <div className="row g-4">
                                                {/* Pharmacy Details */}
                                                <div className="col-12">
                                                    <h5 className="fw-bold mb-3">
                                                        <MdLocalPharmacy className="me-2" size={20} /> {t("Pharmacy Information")}
                                                    </h5>
                                                </div>
                                                <div className="col-md-8">
                                                    <label className="form-label fw-semibold">{t("Pharmacy Name")}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="facility_name"
                                                        value={formData.facility_name}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter pharmacy name")}
                                                    />
                                                    {errors.facility_name && <div className="text-danger small">{errors.facility_name}</div>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("Email")}
                                                        <span className="text-danger">*</span></label>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter email")}
                                                    />
                                                    {errors.email && <div className="text-danger small">{errors.email}</div>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("State")}</label>
                                                    <input
                                                        type="text"
                                                        name="state"
                                                        value={formData.state}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter state")}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("State Code")}</label>
                                                    <input
                                                        type="text"
                                                        name="stateCode"
                                                        value={formData.stateCode}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter state code")}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("Base Currency")}</label>
                                                    <select className="form-select form-select-lg" value={apiData?.baseCurrency || ""} disabled>
                                                        {apiData?.allowedCurrencies?.map(curr => (
                                                            <option key={curr} value={curr}>{curr}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Currency Conversion Rates Section */}
                                                {/* {apiData?.allowedCurrencies && apiData.allowedCurrencies.length > 0 && (
                                                    <>
                                                        <div className="col-12 mt-4">
                                                            <h5 className="fw-bold mb-3">
                                                                <DollarSign className="me-2" size={20} /> {t("Currency Conversion Rates")}
                                                            </h5>
                                                            <p className="text-muted mb-4">
                                                                {t("Set exchange rates relative to base currency")}: <strong>{apiData?.baseCurrency || "INR"}</strong>
                                                            </p>
                                                        </div>

                                                        {apiData.allowedCurrencies.map((currency) => {
                                                            // Skip the base currency as it's always 1:1
                                                            if (currency === apiData?.baseCurrency) return null;

                                                            const currentRate = formData.conversionRates?.[currency] || 0;
                                                            const baseCurrency = apiData?.baseCurrency || "INR";

                                                            return (
                                                                <div className="col-md-6" key={currency}>
                                                                    <div className="card border-light">
                                                                        <div className="card-body">
                                                                            <label className="form-label fw-semibold d-flex align-items-center">
                                                                                <span className="badge bg-primary me-2" style={{ fontSize: '0.9rem' }}>
                                                                                    {currency}
                                                                                </span>
                                                                                {t("Exchange Rate")}
                                                                            </label>
                                                                            <div className="input-group">
                                                                                <span className="input-group-text">
                                                                                    1 {currency} =
                                                                                </span>
                                                                                <input
                                                                                    type="number"
                                                                                    step="0.01"
                                                                                    min="0"
                                                                                    value={currentRate}
                                                                                    onChange={(e) => handleConversionRateChange(currency, e.target.value)}
                                                                                    className="form-control form-control-lg"
                                                                                    placeholder={`Rate in ${baseCurrency}`}
                                                                                />
                                                                                <span className="input-group-text">
                                                                                    {baseCurrency}
                                                                                </span>
                                                                            </div>
                                                                            <div className="form-text mt-2">
                                                                                {t("Current rate")}: 1 {currency} = {currentRate} {baseCurrency}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </>
                                                )} */}

                                                {/* Contact Person */}
                                                <div className="col-12 mt-4">
                                                    <h5 className="fw-bold mb-3">
                                                        <User className="me-2" size={20} /> {t("Contact Person Details")}
                                                    </h5>
                                                </div>
                                                {/* <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("Full Name")}</label>
                                                    <input
                                                        type="text"
                                                        name="full_name"
                                                        value={formData.full_name}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter full name")}
                                                    />
                                                </div> */}
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("First Name")}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="first_name"
                                                        value={formData.first_name}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter first name")}
                                                    />
                                                    {errors.first_name && <div className="text-danger small">{errors.first_name}</div>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("Middle Name")}</label>
                                                    <input
                                                        type="text"
                                                        name="middle_name"
                                                        value={formData.middle_name}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter middle name")}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("Last Name")}
                                                        <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="last_name"
                                                        value={formData.last_name}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter last name")}
                                                    />
                                                    {errors.last_name && <div className="text-danger small">{errors.last_name}</div>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("Contact Email")}
                                                        <span className="text-danger">*</span></label>
                                                    <input
                                                        type="email"
                                                        name="contact_email"
                                                        value={formData.contact_email}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter contact email")}
                                                    />
                                                    {errors.contact_email && <div className="text-danger small">{errors.contact_email}</div>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-semibold">{t("Mobile Number")}</label>
                                                    <PhoneInput
                                                        country="in"
                                                        value={fullPhone}
                                                        onChange={handlePhoneChange}
                                                        enableSearch
                                                        searchPlaceholder={t("Search country...")}
                                                        searchNotFound={t("Country not found")}
                                                        containerClass="custom-phone-container"
                                                        inputClass="form-control form-control-lg custom-phone-input"
                                                        dropdownClass="custom-phone-dropdown"
                                                        buttonClass="custom-phone-button"
                                                    />
                                                </div>
                                                {/* profile picture */}
                                                <div className="col-md-6">
                                                    <label className="form-label fw-semibold">{t("Profile Picture")} </label>
                                                    <input className="form-control" type="file" onChange={handleImageChange} />
                                                </div>
                                                {/* Profile Image Preview */}
                                                <div className="col-md-2">
                                                    {imageSource ? (
                                                        // ✅ Show newly selected image immediately
                                                        <img
                                                            src={imageSource}
                                                            alt="Profile Preview"
                                                            className="frame-box"
                                                            style={{ height: '75px', width: '100%', objectFit: 'cover' }}
                                                            onError={(e) => (e.target.src = errorImage)}
                                                        />
                                                    ) : (
                                                        // ✅ Show image from API / S3
                                                        <S3ImageLoader
                                                            className="frame-box"
                                                            fileName={apiData?.contact_person?.profile_picture}
                                                            style={{ height: '75px', width: '100%', objectFit: 'cover' }}
                                                            alt="Profile"
                                                            fallbackSrc={errorImage}
                                                        />
                                                    )}
                                                </div>
                                                <div className="col-12">
                                                    <label className="form-label fw-semibold">{t("Address")}</label>
                                                    <LoadGoogleMapsAPI onLoad={() => setGoogleMapApiLoaded(true)} />

                                                    {googleMapApiLoaded && (
                                                        <PlacesAutocomplete
                                                            value={formData.address}
                                                            onChange={(value) => handleInputChange(value, 'address')}
                                                            onSelect={handleSelect}
                                                        >
                                                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                <div>
                                                                    <input
                                                                        {...getInputProps({
                                                                            className: "form-control input-font-size",
                                                                            placeholder: "Enter Address",
                                                                            id: "address",
                                                                            name: "address",
                                                                            type: "text",
                                                                        })}
                                                                    />
                                                                    {loading && <div className="loading-indicator">Loading...</div>}
                                                                    {suggestions.length > 0 && (
                                                                        <div className="suggestions-list" style={{
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "4px",
                                                                            maxHeight: "200px",
                                                                            overflowY: "auto",
                                                                            position: "absolute",
                                                                            width: "100%",
                                                                            zIndex: 100,
                                                                        }}>
                                                                            {suggestions.map((suggestion, index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    {...getSuggestionItemProps(suggestion)}
                                                                                    className="suggestion-item"
                                                                                    style={{
                                                                                        padding: "8px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                >
                                                                                    {suggestion.description}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </PlacesAutocomplete>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label fw-semibold">{t("City")}</label>
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        value={formData.city}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter city")}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label fw-semibold">{t("Country")}</label>
                                                    <input
                                                        type="text"
                                                        name="country"
                                                        value={formData.country}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                        placeholder={t("Enter country")}
                                                    />
                                                </div>
                                                {/* Wallet Balance Display */}
                                                {/* {apiData?.wallets && Object.keys(apiData.wallets).length > 0 && (
                                                        <div className="col-12 mt-5">
                                                            <h5 className="fw-bold text-primary mb-4">
                                                                <CreditCard className="me-2" size={20} /> {t("Wallet Balance")}
                                                            </h5>
                                                            <div className="row g-3">
                                                                {Object.entries(apiData.wallets).map(([currency, amount]) => (
                                                                    <div key={currency} className="col-md-4">
                                                                        <div className="border rounded-3 p-4 text-center bg-light">
                                                                            <div className="text-muted small">{t("Balance in")} {currency}</div>
                                                                            <div className="d-flex align-items-center justify-content-center gap-2 mt-2">
                                                                                <span className="fs-3 fw-bold text-dark">
                                                                                    {typeof amount === 'number' ? amount.toLocaleString() : amount}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )} */}
                                                <div className="col-12 text-end mt-5">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                    >
                                                        {t("Update Profile")}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}